import { useQuery } from 'react-query';

import { workScheduleQueryKeys } from './queryKeys';
import { fetchChildWorkSchedules } from './workScheduleApi';

export const useChildWorkSchedulesQuery = ({ workScheduleId }, options) =>
  useQuery(
    workScheduleQueryKeys.childSchedules(workScheduleId),
    () => fetchChildWorkSchedules({ workScheduleId }),
    {
      enabled: Boolean(workScheduleId),
      initialData: [],
      ...options,
    }
  );
